<script lang="ts" setup>
import { computed, onBeforeMount } from "vue";
import Header from "@/components/organisms/common/Header.vue";
import PointCard from "@/components/organisms/mypage/PointCard.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { authStore } from "@/store/auth";
import { accountService } from "@/app/services/AccountService";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import { useCustomRouter } from "@/utils/router";

const loader = useLoader();
const errorModal = useErrorModal();
const customRouter = useCustomRouter();

onBeforeMount(async () => {
  loader.show();
  try {
    // アカウント情報を更新
    await accountService.updateUserData();
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
});

const user = computed(() => authStore.user!);

async function onClickBack() {
  await customRouter.pushIgnoreError({ name: "Mypage" });
}
</script>

<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      ポイント
    </Header>

    <div class="my-point p-3">
      <PointCard :user="user" />

      <div class="mt-3">
        <div class="bg-white border border-outline-color px-3 mt-2 round-4">
          <div class="border-bottom border-outline-color">
            <RouterLink
              :to="{ name: 'ExchangeCoupon' }"
              class="d-flex justify-content-between align-items-center py-3"
            >
              <div class="flex-grow-1">
                <p class="text-black text-size-14">
                  ポイント交換
                </p>
              </div>
              <div class="text-gray-05 flex-grow-0 flex-shrink-0">
                <FeatherIcon icon="chevron-right" size="1x" />
              </div>
            </RouterLink>
          </div>
          <div>
            <RouterLink
              :to="{ name: 'PointHistory' }"
              class="d-flex justify-content-between align-items-center py-3"
            >
              <div class="flex-grow-1">
                <p class="text-black text-size-14">
                  ポイント履歴
                </p>
              </div>
              <div class="text-gray-05 flex-grow-0 flex-shrink-0">
                <FeatherIcon icon="chevron-right" size="1x" />
              </div>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
